<template>
  <v-card :loading="loading" min-height="200px" variant="outlined" class="metric-title bg-white">
    <v-card-title>
      Recent Signups
    </v-card-title>
    <v-divider />

    <v-card-text>
      <v-row>
        <v-col>
          <v-list>
            <v-list-item v-for="(item, index) in metric" :key="index" :to="`users-detail/${item._id}`">
              <v-list-item-title>
                <v-row>
                  <v-col cols="2" class="text-center">
                    <v-avatar size="40" color="indigo-lighten-5">
                      <span class="caption">{{ getInitials(item.name) }}</span>
                    </v-avatar>
                  </v-col>
                  <v-col md="9" lg="10">
                    <span class="font-weight-bold">{{ item.name }}</span> <br/>
                    <span v-if="item.email" class="caption">{{ item.email }}</span>
                    <span v-if="item.phone" class="caption">{{ item.phone }}</span>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider />
    <v-card-actions class="d-flex justify-center">
      <v-btn @click="$emit('view-all-users')">View All Users</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import {useMetricTile} from "@/composables/useMetricTile";
const { metric, loading } = useMetricTile<{
  _id: string;
  name: string;
  email?: string;
  phone?: string;
}[]>("recent-signups");
function getInitials(name: string) {
  if (!name)
    return;

  return name
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

</script>
